export const base_URL = process.env.REACT_APP_BASE_API_URL


// import axios from 'axios';

// const token = sessionStorage.getItem('accessToken');

// const api = axios.create({
//   baseURL: process.env.REACT_APP_BASE_API_URL,
//   headers: {
//     'Content-Type': 'application/json',
//     ...(token && { authorizationToken: token })
//   }
// });

// export default api;